import { Routes } from "@angular/router";
import { DefaultComponentComponent } from "./pages/default-component/default-component.component";
import { AuthGuard } from "./pages/auth/services/auth.guard";

export const routes: Routes = [
  // {
  //   path: "auth",
  //   loadChildren: () =>
  //     import("./pages/auth/auth.module").then((m) => m.AuthModule),
  // },
  {
    path: "error",
    loadChildren: () =>
      import("./modules/errors/errors.module").then((m) => m.ErrorsModule),
  },
  {
    path: "",
    loadChildren: () =>
      import("./_metronic/layout/layout.module").then((m) => m.LayoutModule),
  },
  { path: "**", redirectTo: "error/404" },
];
